/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ListItemPatientChatActivityEmpty_EmbedPatient = {
    readonly firstname: string | null;
    readonly lastname: string | null;
    readonly " $fragmentRefs": FragmentRefs<"AvatarNode_EmbedNode">;
    readonly " $refType": "ListItemPatientChatActivityEmpty_EmbedPatient";
};
export type ListItemPatientChatActivityEmpty_EmbedPatient$data = ListItemPatientChatActivityEmpty_EmbedPatient;
export type ListItemPatientChatActivityEmpty_EmbedPatient$key = {
    readonly " $data"?: ListItemPatientChatActivityEmpty_EmbedPatient$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListItemPatientChatActivityEmpty_EmbedPatient">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListItemPatientChatActivityEmpty_EmbedPatient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastname",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvatarNode_EmbedNode"
    }
  ],
  "type": "Patient",
  "abstractKey": null
};
(node as any).hash = '910fbc09363b71521d12405d89158a73';
export default node;
